// extracted by mini-css-extract-plugin
export var root = "ScrollTop-module--root--ltsP5";
export var icon = "ScrollTop-module--icon--8KkPc";